module.exports = __webpack_public_path__ + "img/flecha-abajo.c8fdc80c.svg";